<div class="d-flex flex-column w-100">
  <div class="header d-flex flex-row px-3 pt-1 w-100">
    <div class="p-2 flex-fill overflow-hidden">
      <h5>{{ 'DatenQuellen' | translate }}</h5>
      <span innerHTML="{{ 'DatenQuellen Beschreibung' | translate }}"></span>
    </div>
  </div>

  <dx-data-grid [dataSource]="productDataSources"
                (onSaved)="onSaved($event)"
                [allowColumnReordering]="true"
                [repaintChangesOnly]="true"
                [rowAlternationEnabled]="true"
                [allowColumnResizing]="true"                
                [height]="1000"
                [selection]="{ allowSelectAll: false }">
    <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
    <dxo-column-chooser enabled="true"></dxo-column-chooser>
    <dxo-search enabled="true"></dxo-search>
    <dxo-editing mode="batch"
                 [(changes)]="changes"
                 [allowAdding]="true"
                 [allowUpdating]="true"
                 [allowDeleting]="true"></dxo-editing>
    <dxo-paging enabled="true"></dxo-paging>
    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="productDataSources"></dxo-state-storing>
    <dxo-search-panel enabled="true"></dxo-search-panel>

    <dxi-column title="{{ 'Name' | translate }}" dataField="name"></dxi-column>
    <dxi-column title="{{ 'Beschreibung' | translate }}" dataField="description"></dxi-column>
    <dxi-column title="{{ 'Typ' | translate }}"
                dataField="type"
                editCellTemplate="typTemplate"
                showEditorAlways="true"></dxi-column>
    <div *dxTemplate="let cellInfo of 'typTemplate'">
      <dx-lookup [items]="types"
                 [value]="cellInfo.value"
                 (onValueChanged)="cellInfo.setValue($event.value)"></dx-lookup>
    </div>

    <dxi-column title="{{ 'Alternative Namen' | translate }}"
                dataField="alternativeNames"
                editCellTemplate="altNamesTemplate"
                showEditorAlways="true"></dxi-column>
    <div *dxTemplate="let cellInfo of 'altNamesTemplate'">
      <dx-tag-box [value]="cellInfo.value"
                  [acceptCustomValue]="true"
                  (onValueChanged)="cellInfo.setValue($event.value)"></dx-tag-box>
    </div>

    <dxi-column title="{{ 'KreditorNr' | translate }}" dataField="kreditorNr"></dxi-column>

    <dxi-column title="{{ 'Ansprechpartner' | translate }}" dataField="contactPerson"></dxi-column>
    <dxi-column title="{{ 'Support Telefon' | translate }}" dataField="supportTel"></dxi-column>
    <dxi-column title="{{ 'Support E-Mail' | translate }}" dataField="supportMail"></dxi-column>
    <dxi-column title="{{ 'Website' | translate }}" dataField="website"></dxi-column>

    <dxi-column title="{{ 'Logo' | translate }}" dataField="logoFile"></dxi-column>
    <dxi-column title="{{ 'Garantieseiten' | translate }}" dataField="warrantyPages"></dxi-column>

    <dxi-column title="{{ 'Country Code' | translate }}"
                dataField="countryCode"
                editCellTemplate="countryCodeTemplate"
                showEditorAlways="true"></dxi-column>
    <div *dxTemplate="let cellInfo of 'countryCodeTemplate'">
      <dx-lookup [items]="countryCodes"
                 [value]="cellInfo.value"
                 [searchEnabled]="true"
                 searchMode="startswith"
                 (onValueChanged)="cellInfo.setValue($event.value)"></dx-lookup>
    </div>

    <dxi-column title="{{ 'Adresse' | translate }}"
                dataField="address"
                cellTemplate="addressTemplate"
                cssClass="p-0"
                [allowEditing]="false"></dxi-column>
    <div *dxTemplate="let cellInfo of 'addressTemplate'">
      <dx-text-area [items]="types"
                    [(value)]="cellInfo.value"
                    (onValueChanged)="onValueChanged($event, cellInfo)"></dx-text-area>
    </div>

    <dxi-column title="{{ 'Zusatzinformationen' | translate }}"
                dataField="additionalInformation"
                cellTemplate="additionalInfoTemplate"
                cssClass="p-0"
                [allowEditing]="false"></dxi-column>
    <div *dxTemplate="let cellInfo of 'additionalInfoTemplate'">
      <dx-text-area [items]="types"
                    [(value)]="cellInfo.value"
                    (onValueChanged)="onValueChanged($event, cellInfo)"></dx-text-area>
    </div>

    <dxo-master-detail [enabled]="true" template="detailTemplate"></dxo-master-detail>
    <div *dxTemplate="let detail of 'detailTemplate'">
      <dx-box direction="row" width="100%" class="np-form-control" [ngStyle]="{ gap: '1.5rem' }">
        <!-- Left Column: Image Preview and Upload -->
        <dxi-item [ratio]="1">
          <div class="dx-card p-3">
            <div class="dx-fieldset">
              <div class="dx-fieldset-header">{{ 'Logo' | translate }}</div>
              <div class="d-flex flex-column justify-content-center align-items-center gap-3">
                <span *ngIf="!detail.data.logoFile"
                      class="glyphicon glyphicon-picture"
                      [ngStyle]="{ fontSize: '25ch', marginBlock: '2rem' }"></span>
                <img *ngIf="detail.data.logoFile"
                     [src]="detail.data.logoFile"
                     alt="Logo Preview"
                     class="logo-preview mb-2" />
                <dx-file-uploader uploadUrl="api/DataSources/UploadLogo"
                                  [allowedFileExtensions]="['.jpg', '.jpeg', '.png', '.gif']"
                                  [uploadHeaders]="uploadHeaders"
                                  [uploadCustomData]="{
                  dataSourceId: detail.data.id,
                  customerId: loginService.currentUser.customerId
                }"
                                  [multiple]="false"
                                  accept="*"
                                  (onUploaded)="onUploaded()"
                                  (onBeforeSend)="onBeforeSendUpload($event)"
                                  [(value)]="value"
                                  uploadMode="instantly"></dx-file-uploader>
              </div>
            </div>
          </div>
        </dxi-item>

        <!-- Right Column: Editable Fields -->
        <dxi-item [ratio]="3">
          <div class="dx-card p-3">
            <div class="dx-fieldset">
              <div class="dx-fieldset-header">{{ 'Details' | translate }}</div>

              <!-- Name -->
              <div class="dx-field">
                <div class="dx-field-label">{{ 'Name' | translate }}</div>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="detail.data.name" [showClearButton]="true"></dx-text-box>
                </div>
              </div>

              <!-- Description -->
              <div class="dx-field">
                <div class="dx-field-label">{{ 'Beschreibung' | translate }}</div>
                <div class="dx-field-value">
                  <dx-text-area [(value)]="detail.data.description" [autoResizeEnabled]="true"></dx-text-area>
                </div>
              </div>

              <!-- Type -->
              <div class="dx-field">
                <div class="dx-field-label">{{ 'Typ' | translate }}</div>
                <div class="dx-field-value">
                  <dx-lookup [items]="types" [(value)]="detail.data.type"></dx-lookup>
                </div>
              </div>

              <!-- Other Fields -->
              <div class="dx-field" *ngFor="let field of ['kreditorNr', 'supportTel', 'supportMail', 'website']">
                <div class="dx-field-label">{{ field | translate }}</div>
                <div class="dx-field-value">
                  <dx-text-box [(value)]="detail.data[field]" [showClearButton]="true"></dx-text-box>
                </div>
              </div>

              <!-- Country Code -->
              <div class="dx-field">
                <div class="dx-field-label">{{ 'Country Code' | translate }}</div>
                <div class="dx-field-value">
                  <dx-lookup [items]="countryCodes" [(value)]="detail.data.countryCode"></dx-lookup>
                </div>
              </div>
            </div>
          </div>
        </dxi-item>
      </dx-box>
    </div>
  </dx-data-grid>
</div>

<dx-popup
  [(visible)]="popupVisible"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [width]="500"
  height="auto"
  [showTitle]="true"
  title="{{ 'Datenquelle bearbeiten' | translate }}"
  [showCloseButton]="true"
>
  <div *dxTemplate="let data of 'content'">
    <dx-box direction="row" width="100%" class="np-form-control" [ngStyle]="{ gap: '1.5rem' }">
      <!-- Left Column: Image Preview and Upload -->
      <dxi-item [ratio]="1">
        <div class="dx-card p-3">
        <div class="dx-fieldset">
          <div class="dx-fieldset-header">{{ 'Logo' | translate }}</div>
          <div class="d-flex flex-column justify-content-center align-items-center gap-3">
            <span
              *ngIf="!data.logoFile"
              class="glyphicon glyphicon-picture"
              [ngStyle]="{ fontSize: '25ch', marginBlock: '2rem' }"
            ></span>
            <img
              *ngIf="data.logoFile"
              [src]="data.logoFile"
              alt="Logo Preview"
              class="logo-preview mb-2"
            />
            <dx-file-uploader
              uploadUrl="api/DataSources/UploadLogo"
              [allowedFileExtensions]="['.jpg', '.jpeg', '.png', '.gif']"
              [uploadHeaders]="uploadHeaders"
              [uploadCustomData]="{
                dataSourceId: data.id,
                customerId: loginService.currentUser.customerId
              }"
              [multiple]="false"
              accept="*"
              (onUploaded)="onUploaded()"
              (onBeforeSend)="onBeforeSendUpload($event)"
              [(value)]="value"
              uploadMode="instantly"
            ></dx-file-uploader>
          </div>
        </div>
      </div>
      </dxi-item>

      <!-- Right Column: Editable Fields -->
      <dxi-item [ratio]="3">
        <div class="dx-card p-3">
          <div class="dx-fieldset">
            <div class="dx-fieldset-header">{{ 'Details' | translate }}</div>

            <!-- Name -->
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Name' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="data.name" [showClearButton]="true"></dx-text-box>
              </div>
            </div>

            <!-- Description -->
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Beschreibung' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-area [(value)]="data.description" [autoResizeEnabled]="true"></dx-text-area>
              </div>
            </div>

            <!-- Type -->
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Typ' | translate }}</div>
              <div class="dx-field-value">
                <dx-lookup [items]="types" [(value)]="data.type"></dx-lookup>
              </div>
            </div>

            <!-- Other Fields -->
            <div class="dx-field" *ngFor="let field of ['kreditorNr', 'supportTel', 'supportMail', 'website']">
              <div class="dx-field-label">{{ field | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="data[field]" [showClearButton]="true"></dx-text-box>
              </div>
            </div>

            <!-- Country Code -->
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Country Code' | translate }}</div>
              <div class="dx-field-value">
                <dx-lookup [items]="countryCodes" [(value)]="data.countryCode"></dx-lookup>
              </div>
            </div>
          </div>
        </div>
      </dxi-item>
    </dx-box>
  </div>
</dx-popup>
